import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@mui/material/Tooltip';

import LoadingButton from 'components/Shared/LoadingButton';
import MessageDialog from 'components/Shared/MessageDialog';

import { checkClientFermeWarning } from 'utils/clientHelper';


const ContenuDialogClientFerme = "Ce compte est fermé, les retours volontaires et SAV ne sont pas autorisés. Se rapprocher de la comptabilité pour plus d'informations."


const CreateButton = ({ nextStepValid, isAdding, validationErrors, onClose, onSubmit, reclamation, autoriseSAV }) => {


    const [tooltip, setTooltip] = React.useState('');
    const [dialogOpen, setDialogOpen] = React.useState(false);


    // MAJ du tooltip en fonction des erreurs de validation
    React.useEffect(() => {
        if (validationErrors && validationErrors.length > 0) {
            setTooltip(validationErrors[0].errorMsg);
        }
        else {
            setTooltip('');
        }
    }, [validationErrors]);


    React.useEffect(() => {
        setDialogOpen(false);
    }, [reclamation.precedenteReclamationId]);


    const handleSubmit = () => {
        if (checkClientFermeWarning(reclamation, autoriseSAV))
        {
            setDialogOpen(true);
        }
        else
        {
            onSubmit();
        }
    };


    return (
        <React.Fragment>

            <MessageDialog
                titre="Avertissement"
                contenu={ContenuDialogClientFerme}
                ouvert={dialogOpen}

                texteNOK="Annuler"
                texteOK="Créer"

                onNOK={onClose}
                onOK={onSubmit}

            />

            {tooltip && (

                <Tooltip title={tooltip}>
                    <span>

                        <LoadingButton
                            disabled={isAdding || !nextStepValid}
                            onClick={handleSubmit}
                            label="Créer"
                            pending={isAdding}
                        />
                    </span>
                </Tooltip>
            )}

            {!tooltip && (
                <LoadingButton
                    disabled={isAdding || !nextStepValid}
                    onClick={handleSubmit}
                    label="Créer"
                    pending={isAdding}
                />
            )}

        </React.Fragment>

    );

}

CreateButton.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    nextStepValid: PropTypes.bool.isRequired,
    validationErrors: PropTypes.array.isRequired,
    isAdding: PropTypes.bool.isRequired,
    reclamation: PropTypes.object.isRequired,
    autoriseSAV: PropTypes.bool.isRequired,
};

export default CreateButton;